import MyDeliveries from './MyDeliveries';

export default MyDeliveries;
